import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

function DeprecateIcon(props) {
    return (
        <SvgIcon {...props}>
           <path className="a" d="M0,0H24V24H0Z" fill="none"/>
           <path className="b" fill="#616161" d="M21,19.1H3V5H21ZM21,3H3A2.006,2.006,0,0,0,1,5V19a2.006,2.006,0,0,0,2,2H21a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,21,3Z"/>
           <path className="a" d="M21,19.1H3V5H21ZM21,3H3A2.006,2.006,0,0,0,1,5V19a2.006,2.006,0,0,0,2,2H21a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,21,3Z" fill="none"/>
           <path className="b" fill="#616161" d="M14.59,8,12,10.59,9.41,8,8,9.41,10.59,12,8,14.59,9.41,16,12,13.41,14.59,16,16,14.59,13.41,12,16,9.41Z"/>
        </SvgIcon>
    );
}

export default DeprecateIcon;